export default __webpack_public_path__ + "static/media/line-awesome.3400fa38.eot";